// extracted by mini-css-extract-plugin
module.exports = {"primary":"#0d4f9d","secondary":"#ff1744","active":"StatusLabel_active__1rMIG","inactive":"StatusLabel_inactive__387uA"};